import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const LayoutPage = ({ listLayoutPage }) => {
    return (
        <div className="teboil-layout-page">
            <FullWrapper>
                <div className="teboil-layout-pageWrapper">
                    <div className="teboil-layout-pageTitle">Верстка страниц</div>
                    <div className="teboil-layout-pageInner">
                        <div className="teboil-layout-pageLeft">
                            <div>
                                После завершения работы над дизайн-макетом приступили к&nbsp;этапу
                                верстки, на&nbsp;котором картинка становится живой. Вёрстка сайта
                                подсвечивает все недочеты, которые могут быть в&nbsp;макете.
                                В&nbsp;нашем агентстве есть специальные регламенты и&nbsp;отдельный
                                этап&nbsp;&mdash; подготовка макетов к&nbsp;вёрстке. Менеджер
                                проекта контролирует файлы, их&nbsp;техническое соответствие для
                                следующего этапа работы по&nbsp;сайту. Перед интеграцией с&nbsp;CMS
                                проверили все страницы и&nbsp;разделы будущего сайта на&nbsp;наличие
                                ошибок.
                            </div>
                            <div>
                                На&nbsp;следующем этапе проработали с&nbsp;заказчиком
                                административную часть: структуру каталога, торгового предложения,
                                процесс создания заказа и&nbsp;логику взаимодействия
                                с&nbsp;заказами.
                            </div>
                            <div>
                                Отдельно реализовали двухстороннее интеграционное взаимодействие
                                с&nbsp;фулфилмент-оператором, настроив обмен заказами, статусами,
                                остатками, дополнительной информацией по&nbsp;заказам и&nbsp;много
                                другое. К&nbsp;интернет-магазину подключили удобный интернет
                                эквайринг для возможности оплачивать заказ онлайн.
                            </div>
                        </div>
                        <div className="teboil-layout-pageRight">
                            В&nbsp;нашем агентстве есть специальные регламенты и&nbsp;отдельный
                            этап&nbsp;&mdash; подготовка макетов к&nbsp;вёрстке.
                        </div>
                    </div>
                    {listLayoutPage.map((item, index) => (
                        <div className="teboil-layout-pageList" key={index}>
                            <div
                                className="teboil-layout-pageName"
                                dangerouslySetInnerHTML={{ __html: item.name }}
                            />
                            <img src={item.image} alt="img" className="teboil-layout-pageImage" />
                        </div>
                    ))}
                </div>
            </FullWrapper>
        </div>
    );
};

export default LayoutPage;
